'use client';

import { useInject } from '@actr/di/src/hook/use-inject';
import { SeoReviewItem } from '@actr/stores/src/stores/models/seo/review';
import { AppStore } from '@actr/stores/src/stores/stores/common/app';
import { ThemeColorValueImportance } from '@actr/style/src/specs/theme-v2';
import { Text } from '@actr/ui/src/components/_atoms/text';
import { Modal } from '@actr/ui/src/components/_modals/modal';
import { observer } from 'mobx-react-lite';
import React from 'react';

import StarRating from '@/components/reviews/stars-rating';
import { getFormattedDate } from '@/utils/get-formated-date';

import * as Styled from '../style.css';

export type ReviewModalProps = SeoReviewItem & {
    isShowModal: boolean;
    onClose: () => void;
}

const ReviewModal: React.FC<ReviewModalProps> = ({
  rating, user, date, review, answer, isShowModal, onClose
}) => {

  const app = useInject(AppStore);
  const { isMobile } = app;

  function renderTitle() {
    return (
      <div className={Styled.TitleReviewModalWrap}>
        <Text font="title.l">
          {user}
        </Text>
        <Text font="paragraph.s" color={ThemeColorValueImportance.LIGHTER}>
          {date}
        </Text>
      </div>
    );
  }

  return (
    <Modal
      className={Styled.Modal()}
      Title={renderTitle()}
      isPopup={!isMobile}
      open={isShowModal}
      onClose={onClose}
      hideFooter={true}>
      <div className={Styled.ReviewModalWrapper}>
        <StarRating readOnly={true} ratingFromReview={rating} />
        <Text font="paragraph.s">{review}</Text>
        {answer && (
        <div className={Styled.AnswerWrapp}>
          <Text font="paragraph.s" color={ThemeColorValueImportance.LIGHTER}>
            Ответ:
          </Text>
          <Text font="paragraph.s">
            {answer.text}
          </Text>
          <Text font="paragraph.s.bold">
            {answer.company}
          </Text>
          <Text font="paragraph.s" color={ThemeColorValueImportance.LIGHTER}>
            {getFormattedDate(answer.date)}
          </Text>
        </div>
        )}
      </div>
    </Modal>
  );
};

export default observer(ReviewModal);
